import React from 'react';

const BenefitsComponent = ({title,context, contentObj,benfits}) => {
  return (
    <div className="videoWrap">
      <div className="videocont">
        <h3>{title}</h3>
        <p>{context}</p>
      </div>
      <div className="videocont">
        <ol style={{paddingLeft: 15}}>
        {contentObj.map((item, index) => (
            <li key={index}>
              <h3 style={{ marginBottom: 0 }}>{item.title}</h3>
              <p>{item?.context}</p>
            </li>
          ))}
        </ol>
      </div>
      <div className="videocont">
        <p>{benfits}</p>
      </div>
    </div>
  )
}

export default BenefitsComponent
